export default "__VITE_ASSET__CnpPUtQo__ 640w, __VITE_ASSET__BByp4Fzz__ 1024w, __VITE_ASSET__D_2nmp2i__ 1536w";